export default __webpack_public_path__ + "static/media/pic43.40ab2b3a.jpg";